"use strict";import{SwatchGroup as e}from"./src/SwatchGroup.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-swatch-group",e);
//# sourceMappingURL=sp-swatch-group.js.map
